module.exports = __webpack_public_path__ + "img/icon-arrow-right.deaa68b8.svg";